import { produce } from 'immer';
import {
  SET_ALL_MESSAGE_TEMPLATES,
  SET_ALL_SEGMENTS,
  SET_MESSAGE_CONTENT,
  SET_MESSAGE_TEMPLATE_DETAIL,
  SET_SELECTED_TEMPLATE,
} from '../actions/nudgeActionTypes';

const initialState = {
  greeting: '',
  segmentList: [],
  createdMessageTemplateName: '',
  messageTemplateList: [],
  messageTemplateDetailList: [],
  selectedMessageTemplate: {},
};

export default function nudge(state = initialState, action) {
  return produce(state, draftState => {
    switch (action.type) {
      case SET_ALL_SEGMENTS: {
        draftState.segmentList = action.payload;
        break;
      }

      case SET_MESSAGE_CONTENT: {
        draftState.createdMessageTemplateName = action.payload;
        break;
      }

      case SET_ALL_MESSAGE_TEMPLATES: {
        draftState.messageTemplateList = action.payload;
        break;
      }

      case SET_MESSAGE_TEMPLATE_DETAIL: {
        draftState.messageTemplateDetailList = action.payload;
        break;
      }
      case SET_SELECTED_TEMPLATE: {
        draftState.selectedMessageTemplate = action.payload;
        break;
      }
      default: {
        break;
      }
    }
  });
}
